export const okButton = "$fb";
export default {okButton};